import { forwardRef, type Ref, type SVGProps } from "react";
const IconSpamFolderOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M4 27h24a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H15.46l-1.7-2.55a1 1 0 0 0-.83-.45H4a2 2 0 0 0-2 2v19a2 2 0 0 0 2 2M4 6h8.39l1.41 2.11.59.89H28v16H4Z"
    />
    <path
      fill="currentColor"
      d="M19.59 12.2a6 6 0 0 0-8.39 8.39 5.8 5.8 0 0 0 1.21 1.21 6 6 0 0 0 8.39-8.39 5.8 5.8 0 0 0-1.21-1.21M11.71 17a4.28 4.28 0 0 1 6.65-3.57l-5.93 5.93a4.27 4.27 0 0 1-.72-2.36M16 21.29a4.27 4.27 0 0 1-2.36-.72l5.93-5.93A4.28 4.28 0 0 1 16 21.29"
    />
  </svg>
);
const ForwardRef = forwardRef(IconSpamFolderOutlineSVG);
ForwardRef.displayName = "IconSpamFolderOutline";
export { ForwardRef as IconSpamFolderOutline };
